import React, { memo, useMemo } from "react";

import { useTranslation } from "react-i18next";

import SelectBox from "../selectBox/SelectBox";
import { SELECT_BOX_TYPES } from "../selectBox/types/selectBoxTypes";

import type { OfferFormState } from "./offerAdapter";
import type { SmartlistItem } from "../../api/SmartlistAPI.types";
import type {
  SelectBoxDisplayItem,
  SelectBoxTab,
} from "../selectBox/selectBox.types";

type OfferSelectBoxFilter = "not_free" | "not_in_offer";

const FILTER_LIST: OfferSelectBoxFilter[] = ["not_free", "not_in_offer"];

const TAB_LIST: SelectBoxTab[] = [
  { key: "contents", icon: "videocam", index: 0 },
  { key: "audios", icon: "queue_music", index: 1 },
];

type OfferMediaSelectBoxItem = Pick<SmartlistItem, "content_uuid"> & {
  content_type: "video";
};

interface OfferSelectBoxProps {
  item: Pick<OfferFormState, "label" | "medias">;
  onChangeItems: (items: SelectBoxDisplayItem[]) => void;
}

function OfferSelectBox({ item, onChangeItems }: OfferSelectBoxProps) {
  const { t } = useTranslation("editor-offers");

  const mediaSelectBoxItemList = useMemo<OfferMediaSelectBoxItem[]>(() => {
    if (!item.medias) return [];

    return item.medias.map((media) => ({
      content_uuid: media.uuid,
      content_type: "video",
    }));
  }, [item.medias]);

  return (
    <SelectBox
      ignoreSmartlistsAudios
      filters={FILTER_LIST}
      items={mediaSelectBoxItemList}
      label={t("offerElements", { offer: item.label })}
      onChangeItems={onChangeItems}
      selectBoxType={SELECT_BOX_TYPES.OFFERS}
      tabs={TAB_LIST}
    />
  );
}

export default memo(OfferSelectBox);
